<template>
  <v-menu
    v-model="dialog"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formatDate"
        :error-messages="errors"
        :class="css"
        :rounded="rounded"
        outlined
        :dense="dense"
        :label="label"
        readonly
        v-bind="attrs"
        :hide-details="hide_details"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :no-title="no_title"
      @input="emit()"
      @change="emit()"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {},
    errors: {},
    label: { type: String },
    css: { type: String },
    no_title: { type: Boolean, default: true },
    rounded: { type: Boolean, default: false },
    dense: { type: Boolean, default: true },
    hide_details: { type: Boolean, default: false },
  },
  data: () => ({
    dialog: false,
    date: '',
  }),
  computed: {
    formatDate() {
      const { date } = this
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
  },
  watch: {
    value(val) {
      this.date = val
    },
  },
  created() {
    this.date = this.value
  },
  methods: {
    emit() {
      this.$emit('input', this.date)
      this.$emit('change', this.date)
      this.dialog = false
    },

  },
}
</script>

<style>
</style>
